import { useShallow } from "zustand/react/shallow";

import { useBillingOnboardingStore } from "./BillingOnboardingModal.store";
import { ModalStyled } from "./BillingOnboardingModal.styles";
import { FormResult, MultiStepForm } from "./components";

function BillingOnboardingModal() {
  const {
    isFormSuccess,
    isModalOpen,
    setCurrentStep,
    setIsFormSuccess,
    toggleModal,
  } = useBillingOnboardingStore(
    useShallow(state => ({
      isFormSuccess: state.isFormSuccess,
      isModalOpen: state.isModalOpen,
      setCurrentStep: state.setCurrentStep,
      setIsFormSuccess: state.setIsFormSuccess,
      toggleModal: state.toggleModal,
    })),
  );

  const handleOnClose = () => {
    toggleModal();
    setCurrentStep(0);
    setIsFormSuccess(false);
  };

  return (
    <ModalStyled
      open={isModalOpen}
      onCancel={handleOnClose}
      footer={null}
      width={742}
      centered
    >
      {isFormSuccess
        ? <FormResult />
        : <MultiStepForm />}
    </ModalStyled>
  );
}

export default BillingOnboardingModal;
